export const projectsArray = [
	{
		id: 1,
		title: 'SoundSavvyShop',
		slug: 'soundsavvyshop',
		description:
			'This is a dynamic and responsive e-commerce platform that revolutionizes the online shopping experience. Seamlessly crafted to empower users, it offers an intuitive interface enabling hassle-free product selection and cart management.',
		background:
			"SoundSavvyShop redefines e-commerce, offering a user-centric platform that simplifies the shopping experience. With an intuitive interface, users effortlessly add, remove, and adjust product quantities in their cart while receiving essential form validations during checkout. Real-time updates ensure accurate checkout totals, followed by a streamlined order confirmation and a comprehensive summary. Integrated with Stripe for secure payments, this innovative application's standout feature is its ability to retain cart items even after browser refresh, ensuring a seamless shopping journey and reflecting a modern, efficient, and enjoyable online shopping experience.",
		technologies: ['JavaScript', 'React', ' Stripe', 'Serverless function'],
		skills: ['Interaction Design', 'Front End Development'],
		link: 'https://soundsavvyshop.netlify.app',
		image: 'soundsavvy/sss-portfolio.png',
		previewImages: [
			'soundsavvy/sss-hero.png',
			'soundsavvy/sss-preview-1.png',
			'soundsavvy/sss-preview-2.png',
		],
	},
	{
		id: 2,
		title: 'JXpense',
		slug: 'jxpense',
		description:
			'JXpense is a dynamic Ruby on Rails mobile web-based application designed to effortlessly manage your expenses and income. With its intuitive interface and no-install-required convenience, JXpense allows users to effortlessly track their financial activities in an efficient and user-friendly manner.',
		background:
			'JXpense Empowers users with control over their financial records, JXpense offers the flexibility to create custom categories and itemize products within these categories, providing a structured and organized approach to expense management. Users can establish an initial budget and have the flexibility to adjust and increase their budget allocation as needed, ensuring a personalized and adaptable financial tracking experience.',
		technologies: [
			'Ruby on Rails',
			'PostgreSQL',
			'Device',
			'Capybara',
			'Rspec',
			'Bootstrap',
		],
		skills: ['Full-stack', 'UI design', 'Project management'],
		link: 'https://jxpense.onrender.com',
		image: 'budget/budget-home-mockup.png',
		previewImages: [
			'budget/Budget-preview3-mockup.png',
			'budget/Budget-preview2-mockup.png',
			'budget/Budget-preview4-mockup.png',
		],
	},
	{
		id: 3,
		title: 'CrowdFunding',
		slug: 'crowdfunding',
		description:
			'A web3.0 crowdfunding app that enable users to create and manage fundraising campaigns, where others can contribute funds to support projects, causes, or businesses.',
		background:
			'Users can set campaign goals, track funding progress, and share updates with supporters, creating a community-driven platform for financing innovative ideas or helping individuals in need.',
		technologies: [
			'Solidity',
			'Hardhat',
			'Tailwind',
			'React/Vite',
			'TypeScript',
			'Thirdweb',
		],
		skills: ['Full-stack', 'Smart contract', 'Decentralized app'],
		link: 'https://crowdfunding-neon.vercel.app/',
		image: 'crowdfunding/crowdfunding.png',
		previewImages: [
			'crowdfunding/crowdfunding.png',
			'crowdfunding/crowdfunding_2.png',
			'crowdfunding/crowdfunding_profile.png',
		],
	},
	{
		id: 4,
		title: 'QuickFeedback',
		slug: 'quickfeedback',
		description:
			'A Ruby on Rails fullstack real-time feedback app that allow users to submit feedback, rate services, and like feedbacks, all without the need for page reloads.',
		background:
			'Users can submit feedback, rate the service, and like feedbacks. All updates happen in real-time without page reloads.',
		technologies: [
			'Ruby 3.1+',
			'Rails 7.1+',
			'PostgreSQL',
			'Hotwire (Turbo + StimulusJS)',
			'RSpec & Capybara for testing',
			'CSS',
		],
		skills: ['Full-stack', 'UI design', 'Project management', 'Testing', 'Agile'],
		link: 'https://github.com/julie-ify/quick-feedback',
		image: 'quickfeedback/quickfeedback-home.png',
		previewImages: [
			'quickfeedback/quickfeedback2.gif',
			'quickfeedback/quickfeedback1.gif',
			'quickfeedback/quickfeedback2.gif',
		],
	},
];

export const findProject = (projectName) => {
	const project = projectsArray.find((project) => {
		return project.slug === projectName;
	});

	return project;
};
